import { render } from "./NewOrderModal.vue?vue&type=template&id=1850100b&scoped=true"
import script from "./NewOrderModal.vue?vue&type=script&lang=js"
export * from "./NewOrderModal.vue?vue&type=script&lang=js"

import "./NewOrderModal.vue?vue&type=style&index=0&id=1850100b&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1850100b"]])

export default __exports__